import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimActsKC2OtherGql } from '../bimWorkOrderOthersQueries';

const requestId = 'bimActsKC2Other';

export const useBimActsKC2Other = (workOrderId?: number, workOrderObjectId?: number, withEffect = false) => {
    const dispatch = useDispatch();
    const [bimActsKC2OtherReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ workOrderId, workOrderObjectId }), [workOrderId, workOrderObjectId]);

    const requestEffect = useMemo(
        () => Boolean(workOrderId) && Boolean(workOrderObjectId) && withEffect,
        [withEffect, workOrderId, workOrderObjectId],
    );

    const [bimActsKC2OtherData, bimActsKC2OtherStatus, , bimActsKC2OtherRequest] = useRequest({
        requestId,
        query: bimActsKC2OtherGql,
        variables,
        withEffect: requestEffect,
    });

    const isBimPresenceActs = !!bimActsKC2OtherData?.bimActsKC2Other?.items?.length;

    useEffect(() => {
        if (withEffect) {
            bimActsKC2OtherReset(undefined);
        }
    }, [bimActsKC2OtherReset, withEffect]);

    const bimActsKC2OtherMakeRequest = useCallback(() => {
        dispatch(bimActsKC2OtherRequest(variables));
    }, [bimActsKC2OtherRequest, dispatch, variables]);

    return {
        bimActsKC2OtherData,
        bimActsKC2OtherStatus,
        bimActsKC2OtherMakeRequest,
        isBimPresenceActs,
    };
};
